import { render, staticRenderFns } from "./BaseBanner.vue?vue&type=template&id=72fdb13b&"
import script from "./BaseBanner.vue?vue&type=script&lang=js&"
export * from "./BaseBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports